import React from 'react';
import type { LucideIcon } from 'lucide-react';

/**
 * Header estándar de página: icono + título + subtítulo, acciones a la
 * derecha en sm+. Tipografía canónica text-xl sm:text-2xl (la mayoritaria
 * en la app); icono default text-accent.
 */
interface PageHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  /** Botones/badges alineados a la derecha en sm+ */
  actions?: React.ReactNode;
  /** Override del color del icono (default text-accent) */
  iconClassName?: string;
  className?: string;
  style?: React.CSSProperties;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  icon: Icon,
  title,
  subtitle,
  actions,
  iconClassName,
  className = '',
  style,
}) => (
  <div
    className={`flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 ${className}`}
    style={style}
  >
    <div>
      <h1 className="text-xl sm:text-2xl font-bold text-content flex items-center">
        <Icon
          className={`h-5 w-5 sm:h-6 sm:w-6 mr-2 flex-shrink-0 ${iconClassName ?? 'text-accent'}`}
        />
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-sm text-content-2">{subtitle}</p>}
    </div>
    {actions && (
      <div className="flex flex-wrap gap-2 w-full sm:w-auto sm:flex-shrink-0">{actions}</div>
    )}
  </div>
);

export default PageHeader;
